export enum PageType {
  TEAM = 'team',
  PLAYER = 'claimedPlayer',
  TEAMPLAYER = 'teamPlayer',
}
